<template>
  <div class="variables-view view">
    <transition name="view__sidebartransition">
      <variables-menu-manager
        v-if="!sidebarClosed"
        :hide="state.netActive"
        @click="clickScenarioMenu"
      />
    </transition>
    <div class="main">
      <variables-net @click="activateNet" @deactivate="deactivateNet" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from "vue";

import { useNetStore } from "@editor/net/net.store";

import VariablesMenuManager from "@editor/views/variables/VariablesMenuManager.vue";
import VariablesNet from "@editor/views/variables/VariablesNet.vue";

import type { Handleable } from "@core/types/Events";

defineOptions({
  name: "VariablesView"
});

const state = reactive({
  netActive: false
});

const sidebarClosed = computed(() => useNetStore().sidebarClosed);

function clickScenarioMenu() {
  deactivateNet();
}

function activateNet(mouseEvent: MouseEvent & Handleable) {
  mouseEvent.hasBeenHandled = true;
}

function deactivateNet() {
  state.netActive = false;
}
</script>
